import { createBrowserRouter, Navigate, RouteObject } from "react-router";

import { enabledFeatures } from "../../features";
import { RouteConstants } from "../../models/enums/route-constants.enum";
import { AuthenticateApp } from "../Core/AuthenticateApp";
import { RouteErrorBoundary } from "../Core/ErrorBoundary/RouteErrorBoundary";
import { lazyRoute } from "./Functions/LazyRoute";
import { AdminAreaGuard, AIFeaturePermissionsGuard, BudgetGuard, TermsOfUseGuard } from "./Guards";

export const router = createBrowserRouter(
  [
    {
      path: "/",
      element: <AuthenticateApp />,
      errorElement: <RouteErrorBoundary />,
      children: [
        {
          path: `/${RouteConstants.Logout}`,
          lazy: lazyRoute({
            importer: () => import("../Pages/Logout/Logout"),
            componentName: "PageLogout",
          }),
        },
        {
          element: <Navigate to={`/${RouteConstants.LandingPage}`} />,
          index: true,
        },
        {
          path: `/${RouteConstants.NoAIFeaturePermissions}`,
          lazy: lazyRoute({
            importer: () => import("../Pages/NoAIFeaturePermissionsPage/NoAIFeaturePermissionsPage"),
            componentName: "NoAIFeaturePermissionsPage",
          }),
        },
        {
          path: `/${RouteConstants.RejectedTermsOfUse}`,
          lazy: lazyRoute({
            importer: () => import("../Pages/TermsOfUseRejectedPage/TermsOfUseRejectedPage"),
            componentName: "TermsOfUseRejectedPage",
          }),
        },
        {
          path: `/${RouteConstants.LandingPage}`,
          lazy: lazyRoute({
            importer: () => import("../Pages/Landing/LandingPage"),
            componentName: "LandingPage",
            guards: [AIFeaturePermissionsGuard, TermsOfUseGuard],
          }),
        },
        {
          path: `/${RouteConstants.NoBudget}`,
          lazy: lazyRoute({
            importer: () => import("../Pages/GlobalErrors/GlobalErrorsPage"),
            componentName: "GlobalErrorsPage",
          }),
        },
        {
          path: `/${RouteConstants.AdminArea}`,
          lazy: lazyRoute({
            importer: () => import("../Pages/AdminArea/AdminPage"),
            componentName: "AdminPage",
            guards: [AdminAreaGuard, TermsOfUseGuard],
          }),
        },
        {
          path: `/${RouteConstants.Ai}`,
          lazy: lazyRoute({
            importer: () => import("../Pages/Feature/FeaturePage"),
            componentName: "FeaturePage",
            guards: [AIFeaturePermissionsGuard, TermsOfUseGuard, BudgetGuard],
          }),
          children: enabledFeatures()
            .map(f => f.route)
            .filter((route): route is RouteObject => !!route),
        },
        {
          path: "*",
          element: <Navigate to={`/${RouteConstants.LandingPage}`} />,
          index: true,
        },
      ],
    },
  ],
  {
    future: {},
  },
);
